module.exports = __webpack_public_path__ + "static/media/orga.3161b8b0.png";